import {Store} from "./models";
import {MarkerClusterer} from "@googlemaps/markerclusterer";
import LatLngLiteral = google.maps.LatLngLiteral;

export class MarkerVisibilityController {

  // =========================
  // 🔹 SYNC MARKERS ON MAP MOVEMENT
  // =========================

  syncMarkersOnBoundsChange(
    markerCluster?: MarkerClusterer,
    map?: google.maps.Map,
    stores?: Store[],
  ) {
    if (map && markerCluster && stores) {
      google.maps.event.addListener(map, 'idle', () => {
        this.updateVisibleMarkers(map, markerCluster, stores);
      });
    }
  }

  // =========================
  // 🔹 UPDATE VISIBLE MARKERS BASED ON BOUNDS
  // =========================

  updateVisibleMarkers(
    map: google.maps.Map,
    cluster: MarkerClusterer,
    stores: Store[]
  ) {
    const bounds = map.getBounds();
    if (!bounds) return;

    const storesOutsideBounds = stores.filter(
      store => !bounds.contains(store.marker.position as LatLngLiteral)
    );

    const storesWithinBounds = stores.filter(
      store => bounds.contains(store.marker.position as LatLngLiteral)
    );

    cluster.removeMarkers(storesOutsideBounds.map(store => store.marker));
    cluster.addMarkers(storesWithinBounds.map(store => store.marker));
  }
}

export const visibilityController = new MarkerVisibilityController();
